module.exports = __webpack_public_path__ + "static/media/LG_FilterTour_s2.1a862dad.gif";